import * as configUtils from "util/config";

export const cedipOptions = ["cedip.list", "cedip.received", "cedip.transmited"];
export const stateActivePendient = "ACTIVO-PENDIENTE";
export const stateActive = "ACTIVO";

// eslint-disable-next-line import/prefer-default-export
export const states = configUtils.getArray("cedips.states", [
    // Crear propertie state
    "TODOS",
    "ACTIVO",
    "ACTIVO-PENDIENTE",
    "DEPOSITADO",
    "PRESENTADO",
    "RECHAZADO",
    "PAGADO",
    "RENOVADO",
]);
export const statusTagColor = (state) => {
    switch (state) {
        case "ACTIVO":
            return "success";
        case "ACTIVO-PENDIENTE":
            return "warning";
        case "DEPOSITADO":
            return "warning";
        case "PRESENTADO":
            return "success";
        case "RECHAZADO":
            return "error";
        case "PAGADO":
            return "error";
        case "RENOVADO":
            return "warning";
        case "ANULADO":
            return "error";
        default:
            return "success";
    }
};

export const statusTransmitTagColor = (state) => {
    switch (state) {
        case "ACEPTADA":
            return "success";
        case "PENDIENTE":
            return "warning";
        case "ANULADA":
        case "REPUDIADA":
            return "error";
        default:
            return "success";
    }
};

export const ceditTransactionWithoutTicket = configUtils.getArray("cedip.activities.without.ticket", [
    "transmit.admit.cedip.send",
    "transmit.anulate.cedip.send",
    "transmit.repudiate.cedip.send",
]);
